import React from "react";

const SellerMaintenancePage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        padding: "24px",
      }}
    >
      <div
        style={{
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          padding: "48px 32px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
        }}
      >
        <div
          style={{
            width: "64px",
            height: "64px",
            margin: "0 auto 24px",
            borderRadius: "50%",
            background: "#fef3c7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "28px",
          }}
        >
          <i className="fas fa-tools" aria-hidden="true" />
        </div>
        <h1 style={{ margin: "0 0 12px", fontSize: "28px", color: "#111827" }}>
          Under Maintenance
        </h1>
        <p style={{ margin: 0, fontSize: "16px", lineHeight: 1.6, color: "#6b7280" }}>
          The seller portal is temporarily unavailable while we perform updates.
          Please check back soon.
        </p>
      </div>
    </div>
  );
};

export default SellerMaintenancePage;
